/** Maps short locale codes used internally to ISO 639-1 + region codes for MFE consumption. */
export const LOCALE_ISO_MAP: Record<string, string> = {
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-GB',
  fi: 'fi-FI',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL',
  no: 'nb-NO',
  pl: 'pl-PL',
  sv: 'sv-SE',
  vls: 'nl-BE',
};
